var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangeProfileImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.92,
    height: 22.92,
    viewBox: "0 0 22.92 22.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11380",
    "data-name": "Group 11380",
    transform: "translate(-415 -159)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_182",
    "data-name": "Ellipse 182",
    cx: 11.46,
    cy: 11.46,
    r: 11.46,
    transform: "translate(415 159)",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11371",
    "data-name": "Group 11371",
    transform: "translate(0.273 -0.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12993",
    "data-name": "Path 12993",
    d: "M426.944,176.012h-6.21a.978.978,0,0,1-.894-.472.754.754,0,0,1-.112-.41q0-3.654,0-7.308a.918.918,0,0,1,.989-.882c1.032,0,2.064,0,3.1,0,.246,0,.492-.007.738,0a.289.289,0,0,0,.306-.2,4.6,4.6,0,0,0,.183-.469,2.174,2.174,0,0,1,.49-.87.8.8,0,0,1,.623-.269c.5.007,1,.017,1.494,0a.935.935,0,0,1,.856.463,2.586,2.586,0,0,1,.354.744c.172.583.194.6.789.6q1.746,0,3.492,0a.976.976,0,0,1,.9.469.767.767,0,0,1,.118.409q0,3.663,0,7.326a.9.9,0,0,1-.925.867c-.324.007-.648,0-.972,0Q429.6,176.014,426.944,176.012Zm0-.97a3.568,3.568,0,1,0-3.571-3.565A3.572,3.572,0,0,0,426.942,175.042Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12994",
    "data-name": "Path 12994",
    d: "M426.946,173.121a1.641,1.641,0,1,1,1.635-1.644A1.659,1.659,0,0,1,426.946,173.121Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeProfileImg);
export default __webpack_public_path__ + "static/media/change-profile-img.470e2cdcaafeb94a65f5b678f52108fa.svg";
export { ForwardRef as ReactComponent };